import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  @font-face {
    font-family: "Sharp Sans";
    src: local("Sharp Sans Regular"),
         url("/fonts/SharpSans.otf") format("opentype");
    font-weight: 400;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: "Sharp Sans";
    src: local("Sharp Sans Medium"),
         url("/fonts/Medium.otf") format("opentype");
    font-weight: 500;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: "Sharp Sans";
    src: local("Sharp Sans SemiBold"),
         url("/fonts/SemiBold.otf") format("opentype");
    font-weight: 600;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: "Sharp Sans";
    src: local("Sharp Sans Bold"),
         url("/fonts/Bold.otf") format("opentype");
    font-weight: 700;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: "Sharp Sans";
    src: local("Sharp Sans ExtraBold"),
         url("/fonts/ExtraBold.otf") format("opentype");
    font-weight: 800;
    font-style: normal;
    font-display: fallback;
  }

  * {
    font-family: "Sharp Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    font-family: "Sharp Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;

export default GlobalStyle; 